/** Navigation targets for the connection pages under `/external-data/integrations`. */
export const CONNECTION_PATHS = {
  connectionsAdd: '/external-data/integrations/$integration/connections/add',
  connectionsUpdate:
    '/external-data/integrations/$integration/connections/$connection/update',
} as const;
